// Universal link the Nebula Mobile app claims. Prod-only by design: the app's associated-domains
// entitlement names this host, so a staging URL would open the browser instead of the app.
const MOBILE_ENROLLMENT_ENDPOINT = 'https://api.defined.net/v1/mobile-enrollment';

/**
 * Build the deep link that hands a single-use enrollment code to the Nebula Mobile app.
 *
 * The code travels in the URL *fragment*, not a query param: fragments are never sent to the
 * server, so the code stays out of api.defined.net's request logs and out of any intermediary's.
 * Encoding it is load-bearing — an unescaped `#` or `&` would truncate the code client-side, where
 * no server error can report it.
 */
export function mobileEnrollLink(code: string) {
  return `${MOBILE_ENROLLMENT_ENDPOINT}#code=${encodeURIComponent(code)}`;
}
